import { Settings } from '../Settings.js';

// Frames simulated in the current attempt. Gameplay timers read this instead of
// the wall clock, so they behave the same on every machine and in replays.
let frame = 0;

export const resetSimulationClock = () => {
	frame = 0;
};

export const advanceSimulationClock = () => {
	frame++;
};

export const simulationFrame = () => frame;

// Milliseconds at the nominal frame rate, for timers tuned in wall-clock time.
export const simulationTime = () => frame * Settings.timeStep;
